var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 15456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 15441"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55",
    cx: 11.1111,
    cy: 38.8885,
    r: 10.8333,
    stroke: "#FF2D20",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56",
    cx: 36.1111,
    cy: 11.1111,
    r: 10.8333,
    stroke: "#0000FF",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57",
    cx: 22.2223,
    cy: 25.0001,
    r: 19.4444,
    fill: "#00D1FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58",
    cx: 2.77778,
    cy: 5.55512,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 59",
    cx: 46.6667,
    cy: 38.8891,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 15439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 23V28C32 33 30 35 25 35H19C14 35 12 33 12 28V22C12 17 14 15 19 15H24",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32 23H28C25 23 24 22 24 19V15L32 23Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedocumentation);
export default __webpack_public_path__ + "static/media/Completedocumentation.dfbbf1e2a47110aafd965ef36800eccc.svg";
export { ForwardRef as ReactComponent };